
import React, { Component, useEffect, useState } from 'react';
import axios from 'axios';
import FAQ_Card from './FAQ_Card.js';
import Search from '../../Common/Component/Search.js';
import Pagination from '../../Common/Component//Pagination.js';
import '../css/HumanResource.css';
import Text from '../../../common/Text.js';


function FAQ(props) {

  const [remainingHeight, setRemainingHeight] = useState(0);
  const [Display, setDisplay] = useState('none');

  const handleHover = (height) => {
    setRemainingHeight(height);
    console.log('Received Remaining height:', height);
    setDisplay('block');
    console.log('Received Remaining height:', Display);

  };
  const handleHoverEnd = () => {
    console.log('Hover ended in MainComponent');
    setDisplay('none');
  };

  //
  // const [Dbtable, setDbtable] 
  // = useState([]);
  const [GbnGrpCode, setGbnGrpCode] = useState('RC001');


  const [Dbtable, setDbtable] = useState([]);


  useEffect(() => {
    Load();
  }, []);



  const Load = async () => {
    axios.get('/api/Faq')
      .then(response => {
        setDbtable(response.data);
        console.log(response.data);
        setTotal(response.data.length);
      }
      )
      .catch(error => console.error("DB 가져오기 오류", error));
    console.log('total sucess');
  }




  const [page, setPage] = useState(1); //첫페이지를 몇번으로 할건지
  const [limit, setlimit] = useState(10); //한페이지단 보여줄 데이터개수
  const [total, setTotal] = useState(Dbtable.length); // 선택할 몇개까지 나타낼건지
  const offset = (page - 1) * limit;
  const [searchResult, setResult] = useState('');
  const [searchType, setType] = useState('제목');

  const TitleList = Dbtable.slice(offset, offset + limit).filter((dr) => searchResult == '' || dr.Title.includes(searchResult))
  .map((row) => <FAQ_Card class='firstCard'
    Gbn={row.GbnGrpName}
    Title={row.Title}
    Content={row.Answer}
    elemt={row.GbnGrpCode + row.GbnCode + 'C'}
    imgId={row.GbnGrpCode + row.GbnCode + 'I'}
    auth={props.auth}>
  </FAQ_Card>);

const ContentsList = Dbtable.slice(offset, offset + limit).filter((dr) => searchResult == '' || (dr.Answer.includes(searchResult)))
  .map((row) => <FAQ_Card class='firstCard'
    Gbn={row.GbnGrpName}
    Title={row.Title}
    Content={row.Answer}
    elemt={row.GbnGrpCode + row.GbnCode + 'C'}
    imgId={row.GbnGrpCode + row.GbnCode + 'I'}
    auth={props.auth}>
  </FAQ_Card>);

const AllList = Dbtable.slice(offset, offset + limit).filter((dr) => searchResult == '' || (dr.Title.includes(searchResult)) || (dr.Answer.includes(searchResult)))
  .map((row) => <FAQ_Card class='firstCard'
    Gbn={row.GbnGrpName}
    Title={row.Title}
    Content={row.Answer}
    elemt={row.GbnGrpCode + row.GbnCode + 'C'}
    imgId={row.GbnGrpCode + row.GbnCode + 'I'}
    auth={props.auth}>
  </FAQ_Card>);



  const getSearchList = (vlaue, value2) => {
    setResult(vlaue);
    setType(value2);
    if (vlaue != "") {

      setlimit(Dbtable.length);

    } else { setlimit(10); }


    console.log(vlaue);
    console.log(value2);
  };





  return (
    <div >
      {/* <header> <Header class = 'header1' onHover={handleHover} onHoverEnd={handleHoverEnd}/>
            <div style={{ zIndex:2, display:Display,position: 'fixed', bottom: 0, left: 0, right: 0, height:remainingHeight, backgroundColor:'black', width:'100%', opacity:0.6}}/> 
          </header> */}

      <div>
        {/* <img src={Header} style={{width : 1680}}></img> */}


        <div class='group1'>
          <Text variant="titlename" >
            <div class="TitleC">자주 하는 질문</div>
          </Text>

          {props.auth == 'Admin' ? <button class='btnAdd' >추가</button> : ''}
          {props.auth == 'Admin' ? <button class='btnSave' >저장</button> : ''}

          {/* 
        <ImageView upload = '312cef2e-6d71-4e12-9bff-c42147d7223a'/> */}
          <div >
            {searchType == '제목' ? TitleList : ''}
            {searchType == '내용' ? ContentsList : ''}
            {searchType == '제목+내용' ? AllList : ''}
          </div>
          <div >

            <div style={{ display: 'flex', gap: 24, justifyContent: 'center', flexDirection: 'column', borderBottomWidth: 68, paddingBottom: 68, paddingTop: 107 }}>
              {/* <Pagination
                              total = {total}
                              limit = {limit}
                              page={page}
                              setPage={setPage}
                              /> */}

              {Dbtable.length >= 1 &&
                <Pagination
                  total={total}
                  limit={limit}
                  page={page}
                  setPage={setPage}
                />
              }

              <Search getSearchList={getSearchList}
                searchResult={searchResult}
              />
            </div>
          </div>
        </div>
        {/* <img src={Foot} onClick={Load} style={{width : 1680, top : 300}}></img> */}
      </div>
    </div>
  );
}


export default FAQ; 